import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface Banner {
    enabled: boolean;
    shutdownDate: string;
    opcos: string[];
}

@Injectable({providedIn: 'root'})
export class BannerService {
    constructor(private http: HttpClient) {}

    findBanner(): Observable<Banner> {
        return this.http.get<Banner>('/banner')
            .pipe(catchError(() => of(null)));
    }
}

/**
 * The banner is shown for all opcos when no opcos are configured,
 * otherwise only for the configured opcos.
 */
export function isBannerShownForOpCo(banner: Banner, opCo: string): boolean {
    if (!banner || !banner.enabled) {
        return false;
    }
    const opcos = banner.opcos || [];
    return opcos.length === 0 || (opCo != null && opcos.includes(opCo.toUpperCase()));
}
